import { render, staticRenderFns } from "./ActivationBriefProvider.vue?vue&type=template&id=5d848dc8&"
import script from "./ActivationBriefProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports